import classNames from 'classnames';
import type { CSSProperties } from 'react';

export const EMAIL_BUILDER_VERTICAL_ACTION_RAIL_PIN_X_VAR =
  '--email-builder-action-rail-pin-x';
export const EMAIL_BUILDER_VERTICAL_ACTION_RAIL_PIN_Y_VAR =
  '--email-builder-action-rail-pin-y';

export const EMAIL_BUILDER_VERTICAL_ACTION_RAIL_HIDDEN_PIN_STYLE: CSSProperties = {
  position: 'absolute',
  visibility: 'hidden',
  pointerEvents: 'none',
  top: 0,
  left: 0,
};

export const EMAIL_BUILDER_VERTICAL_ACTION_RAIL_VISIBLE_PIN_STYLE: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 'auto',
  display: 'flex',
  visibility: 'visible',
  pointerEvents: 'auto',
  transform: `translate3d(var(${EMAIL_BUILDER_VERTICAL_ACTION_RAIL_PIN_X_VAR}, 0px), var(${EMAIL_BUILDER_VERTICAL_ACTION_RAIL_PIN_Y_VAR}, 0px), 0)`,
};

export function emailBuilderVerticalActionRailClassName(portaled: boolean): string {
  return classNames(
    'email-builder-canvas-rail',
    'email-builder-canvas-action-rail__position',
    portaled && 'email-builder-canvas-action-rail--portaled',
  );
}

export function emailBuilderVerticalActionRailPinStyle(
  portaled: boolean,
  pinStyle: CSSProperties | null,
): CSSProperties | undefined {
  if (!portaled) {
    return undefined;
  }
  return pinStyle ?? EMAIL_BUILDER_VERTICAL_ACTION_RAIL_HIDDEN_PIN_STYLE;
}
